<template>
    <div style="text-align: left !important;">
        <h1>Configuració del sistema</h1>
        <b-form @submit="saveConfiguration" v-show="configLoaded">
            <b-form-group
                    id="read-start-at-group"
                    label="Hora d'inici de la franja per efectuar lectures (en format hh:mm):"
                    label-for="read-start-at"
            >
                <b-form-input
                        :disabled="savingPanel"
                        id="read-start-at"
                        v-model="params.read_panels_start_at"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="read-end-at-group"
                    label="Hora de finalització de la franja per efectuar lectures (en format hh:mm):"
                    label-for="read-end-at"
            >
                <b-form-input
                        id="read-end-at"
                        :disabled="savingPanel"
                        v-model="params.read_panels_end_at"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    id="read-every-minutes-groupt"
                    label="Cada quant efectuar lectures (en minuts):"
                    label-for="read-every-minutes"
            >
                <b-form-input
                        id="read-every-minutes"
                        :disabled="savingPanel"
                        v-model="params.read_panels_every_minutes"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    id="email-every-minutes-group"
                    label="Cada quan enviar emails de notificacions d'alarmes, alertes i/o errors (en minuts):"
                    label-for="email-every-minutes"
            >
                <b-form-input
                        id="email-every-minutes"
                        :disabled="savingPanel"
                        v-model="params.emails_every_minutes"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    id="min-power-average-group"
                    label="Valor mínim de potència per a considerar alertes de potència:"
                    label-for="min-power-average"
            >
                <b-form-input
                        id="min-power-average"
                        :disabled="savingPanel"
                        v-model="params.power_notifications_minimum_average"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="sunrise-minutes-group"
                    label="Minuts a afegir endavant i enrere de la SORTIDA de sol, per obviar alertes (en minuts):"
                    label-for="sunrise-minutes"
            >
                <b-form-input
                        id="sunrise-minutes"
                        :disabled="savingPanel"
                        v-model="params.notifications_sunrise_minutes"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="sunset-minutes-group"
                    label="Minuts a afegir endavant i enrere de la POSTA de sol, per obviar alertes (en minuts):"
                    label-for="sunset-minutes"
            >
                <b-form-input
                        id="sunset-minutes"
                        :disabled="savingPanel"
                        v-model="params.notifications_sunset_minutes"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    id="latitude-group"
                    label="Latitud del camp solar (en el format XXX.YYYYY):"
                    label-for="latitude"
            >
                <b-form-input
                        id="latitude"
                        :disabled="savingPanel"
                        v-model="params.solar_field_latitude"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    id="longitude-group"
                    label="Longitud del camp solar (en el format XXX.YYYYY):"
                    label-for="longitude"
            >
                <b-form-input
                        id="longitude"
                        :disabled="savingPanel"
                        v-model="params.solar_field_longitude"
                        type="text"
                        required
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    id="watch-power-status-group"
                    label="Interpretar els codis d'estat en la medició de potències?"
                    label-for="watch-power-status"
            >
                <b-form-checkbox
                        id="watch-power-status"
                        :disabled="savingPanel"
                        v-model="params.watch_power_measurer_status"
                        value="true"
                        unchecked-value="false"
                ></b-form-checkbox>
            </b-form-group>
            <b-form-group
                    id="watch-position-status-group"
                    label="Interpretar els codis d'estat en la medició de posicions?"
                    label-for="watch-position-status"
            >
                <b-form-checkbox
                        id="watch-position-status"
                        :disabled="savingPanel"
                        v-model="params.watch_position_measurer_status"
                        value="true"
                        unchecked-value="false"
                ></b-form-checkbox>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="savingPanel">Guardar</b-button>
        </b-form>
        <div>&nbsp;</div>
        <b-alert :show="error_message.length>0" variant="danger">{{ error_message }}</b-alert>
        <b-alert :show="saved_ok === true" variant="success">Canvis guardats correctament</b-alert>
    </div>
</template>

<script>
    import Api from "../api"
    import router from "../router"

    export default {
        name: "ConfigurationView",
        data: function () {
            return {
                configLoaded: false,
                params: {
                    read_panels_start_at: null,
                    read_panels_end_at: null,
                    read_panels_every_minutes: null,
                    emails_every_minutes: null,
                    watch_power_measurer_status: null,
                    watch_position_measurer_status: null,
                    power_notifications_minimum_average: null,
                    notifications_sunrise_minutes: null,
                    notifications_sunset_minutes: null,
                    solar_field_latitude: null,
                    solar_field_longitude: null,    
                },
                error_message: '',
                saved_ok: null,
                savingPanel: false
            }
        },
        methods: {
            loadConfiguration() {
                Api.loadConfiguration().then(response => {
                    let config = response.data.data
                    this.params.read_panels_start_at = config.read_panels_start_at
                    this.params.read_panels_end_at = config.read_panels_end_at
                    this.params.read_panels_every_minutes = config.read_panels_every_minutes
                    this.params.emails_every_minutes = config.emails_every_minutes
                    this.params.watch_power_measurer_status = config.watch_power_measurer_status
                    this.params.watch_position_measurer_status = config.watch_position_measurer_status
                    this.params.power_notifications_minimum_average = config.power_notifications_minimum_average
                    this.params.notifications_sunrise_minutes = config.notifications_sunrise_minutes
                    this.params.notifications_sunset_minutes = config.notifications_sunset_minutes
                    this.params.solar_field_latitude = config.solar_field_latitude
                    this.params.solar_field_longitude = config.solar_field_longitude

                    this.configLoaded = true
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                    try {
                        this.error_message = "S'ha detectat un error al carregar la configuració: " + error.response.data.message;
                    } catch (ex) {
                        this.error_message = "S'ha detectat un error però no s'ha pogut obtenir el missatge."
                    }
                })
            },
            saveConfiguration(evt) {
                evt.preventDefault()
                this.savingPanel = true;
                Api.saveConfiguration(this.params).then(() => {
                    this.savingPanel = false
                    this.saved_ok = true
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                    try {
                        this.error_message = "S'ha detectat un error al guardar la configuració: " + error.response.data.message;
                    } catch (ex) {
                        this.error_message = "S'ha detectat un error però no s'ha pogut obtenir el missatge."
                    }
                })
            }
        },
        mounted() {
            if (!this.$store.state.user.can_edit) {
                router.push('/dashboard');
                return;
            }
            this.loadConfiguration()
        }
    }

</script>

<style scoped>

</style>